import {CSSProperties} from 'react';

export enum EButtonAppearance {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  /**
   * @deprecated Use tertiary instead
   */
  default = 'default',
}

export enum EButtonSize {
  L = 'L',
  M = 'M',
  S = 'S',
  XS = 'XS',
  XXS = 'XXS',
}

export type TButtonSize = keyof typeof EButtonSize;

export type TButtonAppearance = keyof typeof EButtonAppearance;

export const ICON_SIZE: Record<TButtonSize, CSSProperties['width']> = {
  [EButtonSize.XXS]: '12px',
  [EButtonSize.XS]: '12px',
  [EButtonSize.S]: '16px',
  [EButtonSize.M]: '20px',
  [EButtonSize.L]: '24px',
};

export enum EShadowType {
  NORMAL = 'NORMAL',
  DISABLED = 'DISABLED',
}
